import React, { useEffect, useRef } from "react";
import { MdArrowBackIosNew } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

function MultipleInvoice() {
  const location = useLocation();
  const { items } = location?.state || { items: [] }; // Expect array of orders
  const navigate = useNavigate();
  const receiptContainerRef = useRef(null);
  const hasPrinted = useRef(false);



  // Function to print all receipts - SIMPLE WORKING VERSION
  const printReceipts = () => {
    if (!items.length) {
      navigate(-1);
      return;
    }

    // Simple approach: just trigger browser print
    window.print();
  };

  useEffect(() => {
    if (hasPrinted.current) return; // Prevent multiple prints

    if (document.readyState === "complete") {
      const timer = setTimeout(() => {
        printReceipts();
        hasPrinted.current = true;
      }, 500);

      return () => clearTimeout(timer);
    } else {
      const handleLoad = () => {
        const timer = setTimeout(() => {
          printReceipts();
          hasPrinted.current = true;
        }, 2000);

        window.removeEventListener("load", handleLoad);
      };

      window.addEventListener("load", handleLoad);

      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);


  // Alternative manual print function for the button
  const handleManualPrint = () => {
    printReceipts();
  };

  return (
    <>
      {/* Add CSS to hide header during print */}
      <style>
        {`
          @media print {
            @page {
              margin: 10mm;
            }
            
            .no-print {
              display: none !important;
            }
            
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              height: auto !important;
            }
            
            .receipt-container {
              background: white !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            
            .thermal-receipt {
              page-break-before: always;
              page-break-after: always;
              page-break-inside: avoid;
              margin: 0 auto !important;
              padding: 8mm !important;
              box-shadow: none !important;
              border-radius: 0 !important;
            }
            
            .thermal-receipt:first-child {
              page-break-before: avoid;
            }
            
            .thermal-receipt:last-child {
              page-break-after: avoid;
            }
          }
        `}
      </style>

      {/* Header - Add no-print class */}
      <div
        className="no-print"
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px",
          backgroundColor: "#f5f5f5",
          alignItems: "center",
        }}
      >
        <MdArrowBackIosNew
          onClick={() => navigate("/packer-dashboard")} // Use navigate instead of window.location.assign
          style={{ color: "black", fontSize: "26px", cursor: "pointer" }}
        />
        <button
          style={{
            cursor: "pointer",
            backgroundColor: "#d81d4a",
            color: "white",
            border: "none",
            padding: "8px 20px",
            borderRadius: "4px",
            fontWeight: "600",
            fontSize: "14px",
            transition: "background-color 0.2s",
          }}
          onClick={handleManualPrint} // Use the manual print function instead of reload
          onMouseOver={(e) => (e.target.style.backgroundColor = "#b5173e")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#d81d4a")}
        >
          PRINT ALL RECEIPTS
        </button>
      </div>

      <div
        className="receipt-container"
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          padding: "20px",
        }}
      >
        <div ref={receiptContainerRef}>
          {items.map((item, index) => {
            const isSchoolKOT = !!item?.counterId && !!item?.studentName;
            const isTeacher = isSchoolKOT && !item?.studentClass && !item?.studentSection;
            return (
              <div
                key={item.orderid || index}
                className="thermal-receipt"
                style={{
                  width: "80mm",
                  backgroundColor: "white",
                  padding: "8mm",
                  fontFamily: "'Courier New', monospace",
                  fontSize: "12px",
                  lineHeight: "1.4",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  fontWeight: 600,
                }}
              >
                {isSchoolKOT ? (
                  /* ── School KOT ── */
                  <>
                    {/* Counter ID */}
                    <div style={{ textAlign: "center", fontSize: "36px", fontWeight: "900", letterSpacing: "3px", marginBottom: "6px" }}>
                      {item.counterId}
                    </div>
                    <div style={{ borderBottom: "1.5px dashed #000", marginBottom: "10px" }} />

                    {/* Person info */}
                    {isTeacher ? (
                      <div style={{ marginBottom: "10px" }}>
                        <div style={{ fontSize: "22px", fontWeight: "900", marginBottom: "4px" }}>{item.studentName || "—"}</div>
                        {item.block && (
                          <div style={{ fontSize: "17px", fontWeight: "900", marginTop: "4px" }}>Block - {item.block}</div>
                        )}
                        {item.Mobilenumber && (
                          <div style={{ fontSize: "15px", fontWeight: "900", marginTop: "4px" }}>{item.Mobilenumber}</div>
                        )}
                        <div style={{ fontSize: "14px", fontWeight: "900", marginTop: "4px", textTransform: "uppercase", letterSpacing: "1.5px" }}>Teacher</div>
                      </div>
                    ) : (
                      <div style={{ marginBottom: "10px" }}>
                        <div style={{ fontSize: "22px", fontWeight: "900", marginBottom: "4px" }}>{item.studentName || "—"}</div>
                        <div style={{ fontSize: "17px", fontWeight: "900" }}>
                          {item.studentClass ? `Class ${item.studentClass}` : ""}
                          {item.studentClass && item.studentSection ? " · " : ""}
                          {item.studentSection ? `Sec ${item.studentSection}` : ""}
                        </div>
                        {item.block && (
                          <div style={{ fontSize: "17px", fontWeight: "900", marginTop: "4px" }}>Block - {item.block}</div>
                        )}
                        {item.Mobilenumber && (
                          <div style={{ fontSize: "15px", fontWeight: "900", marginTop: "4px" }}>{item.Mobilenumber}</div>
                        )}
                        <div style={{ fontSize: "14px", fontWeight: "900", marginTop: "4px", textTransform: "uppercase", letterSpacing: "1.5px" }}>Student</div>
                      </div>
                    )}

                    <div style={{ borderBottom: "1px dashed #000", marginBottom: "8px" }} />

                    {/* Items */}
                    <div>
                      {item?.allProduct?.map((p, idx) => (
                        <div key={idx} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "5px 0", borderBottom: "1px dotted #ccc" }}>
                          <span style={{ fontSize: "17px", fontWeight: "900", flex: 1, paddingRight: "8px", wordBreak: "break-word" }}>
                            {p.name || p.foodItemId?.foodname || "—"}
                          </span>
                          <span style={{ fontSize: "17px", fontWeight: "900", whiteSpace: "nowrap" }}>×{p.quantity || 1}</span>
                        </div>
                      ))}
                    </div>

                    <div style={{ borderTop: "1px dashed #000", marginTop: "10px", paddingTop: "6px", textAlign: "center", fontSize: "11px", fontWeight: "700", color: "#555" }}>
                      {moment().format("DD-MM-YYYY hh:mm A")}
                    </div>
                  </>
                ) : (
                  /* ── Regular Invoice ── */
                  <>
                    {/* Header */}
                    <div style={{ textAlign: "center", marginBottom: "10px" }}>
                      <div style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "4px", fontFamily: "'Imperial Script', cursive", letterSpacing: "1px" }}>
                        DailyDish
                      </div>
                      <div style={{ fontSize: "11px" }}>Bangalore, Karnataka</div>
                      <div style={{ fontSize: "11px" }}>GSTIN: 29AAMCC3615N1Z6</div>
                      <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>
                    </div>

                    {/* Order Info */}
                    <div style={{ marginBottom: "10px" }}>
                      <table style={{ width: "100%", fontSize: "11px" }}>
                        <tbody>
                          {(item?.studentClass || item?.studentSection) && (
                            <tr>
                              <td style={{ padding: "2px 0" }}>Student Details :</td>
                              <td style={{ textAlign: "right", padding: "2px 0", fontWeight: "bold", fontSize: "16px" }}>
                                {[item?.studentClass, item?.studentSection].filter(Boolean).join(", ")}
                              </td>
                            </tr>
                          )}
                          {item?.studentName && (
                            <tr>
                              <td style={{ padding: "2px 0" }}>Student Name:</td>
                              <td style={{ textAlign: "right", padding: "2px 0", fontWeight: "bold", fontSize: "16px" }}>
                                {item.studentName}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td style={{ padding: "2px 0" }}>Order #:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>{item?.orderid || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "2px 0" }}>Booking Date:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>
                              {item?.createdAt ? moment(item.createdAt).format("DD-MM-YYYY") : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: "2px 0" }}>Booking Slot:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>{item?.slot || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "2px 0" }}>Delivery Date:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>
                              {item?.updatedAt ? moment(item.updatedAt).format("DD-MM-YYYY hh:mm A") : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: "2px 0" }}>Customer:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>{item?.username || "-"}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "2px 0" }}>Phone No:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>{item?.Mobilenumber}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: "2px 0" }}>Customer Type:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>{item?.customerType || "Normal"}</td>
                          </tr>
                          {item?.riderId && (
                            <tr>
                              <td style={{ padding: "2px 0" }}>Rider:</td>
                              <td style={{ textAlign: "right", padding: "2px 0" }}>{item?.riderId?.name}</td>
                            </tr>
                          )}
                          <tr>
                            <td colSpan={2} style={{ textAlign: "right", padding: "2px 0", fontSize: "14px" }}>
                              {item?.delivarylocation}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>
                    </div>

                    {/* Items Table */}
                    <div>
                      <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0", fontSize: "11px", fontWeight: 600 }}>
                        <thead>
                          <tr style={{ fontWeight: "bold", borderBottom: "1px dashed #000" }}>
                            <td style={{ width: "40%", textAlign: "left", padding: "4px 2px", border: "0.5px solid #555" }}>Item</td>
                            <td style={{ width: "15%", textAlign: "center", padding: "4px 2px", border: "0.5px solid #555" }}>Qty</td>
                            <td style={{ width: "25%", textAlign: "right", padding: "4px 2px", border: "0.5px solid #555" }}>Price</td>
                            <td style={{ width: "20%", textAlign: "right", padding: "4px 2px", border: "0.5px solid #555" }}>Amount</td>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.allProduct?.map((p, idx) => (
                            <tr key={idx}>
                              <td style={{ textAlign: "left", padding: "4px 2px", wordBreak: "break-word", border: "0.5px solid #555" }}>
                                {p?.foodItemId?.foodname || p?.name} (
                                <span className="fw-bolder">{p?.foodItemId?.foodcategory})</span>
                              </td>
                              <td style={{ textAlign: "center", padding: "4px 2px", border: "0.5px solid #555" }}>{p?.quantity || 0}</td>
                              <td style={{ textAlign: "right", padding: "4px 2px", border: "0.5px solid #555" }}>
                                ₹ {p?.totalPrice ? Number(p?.totalPrice / p?.quantity) : "0.00"}
                              </td>
                              <td style={{ textAlign: "right", padding: "4px 2px", border: "0.5px solid #555" }}>
                                ₹ {p?.quantity ? p?.totalPrice : "0.00"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>
                    </div>

                    {/* Totals */}
                    <div>
                      <table style={{ width: "100%", fontSize: "11px" }}>
                        <tbody>
                          <tr>
                            <td style={{ textAlign: "left", padding: "2px 0" }}>Item Total (Excl. Tax):</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>
                              {item?.amountBeforeTax
                                ? Number(item.amountBeforeTax).toFixed(2)
                                : ((item?.subTotal || 0) - (item?.tax || 0)).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left", padding: "2px 0" }}>Delivery:</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>
                              {item?.deliveryCharge <= 0 ? "Free" : `₹ ${Number(item.deliveryCharge).toFixed(2)}`}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left", padding: "2px 0" }}>Tax ({item?.taxPercentage || 5}%):</td>
                            <td style={{ textAlign: "right", padding: "2px 0" }}>
                              ₹{item?.tax ? Number(item.tax).toFixed(2) : "0.00"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left", padding: "2px 0", borderTop: "1px dotted #ccc" }}>Order Value (Inc. Tax):</td>
                            <td style={{ textAlign: "right", padding: "2px 0", borderTop: "1px dotted #ccc", fontWeight: "bold" }}>
                              ₹{((item?.subTotal || 0) + (item?.deliveryCharge || 0)).toFixed(2)}
                            </td>
                          </tr>
                          {item?.Cutlery > 0 && (
                            <tr>
                              <td style={{ textAlign: "left", padding: "2px 0" }}>Cutlery:</td>
                              <td style={{ textAlign: "right", padding: "2px 0" }}>₹{Number(item.Cutlery).toFixed(2)}</td>
                            </tr>
                          )}
                          {item?.coupon > 0 && (
                            <tr>
                              <td style={{ textAlign: "left", padding: "2px 0" }}>Discount:</td>
                              <td style={{ textAlign: "right", padding: "2px 0" }}>-₹ {Number(item.coupon).toFixed(2)}</td>
                            </tr>
                          )}
                          {item?.preorderDiscount > 0 && (
                            <tr>
                              <td style={{ textAlign: "left", padding: "2px 0" }}>Preorder Discount:</td>
                              <td style={{ textAlign: "right", padding: "2px 0" }}>-₹{Number(item.preorderDiscount).toFixed(2)}</td>
                            </tr>
                          )}
                          {item?.discountWallet > 0 && (
                            <tr>
                              <td style={{ textAlign: "left", padding: "2px 0" }}>Wallet Used:</td>
                              <td style={{ textAlign: "right", padding: "2px 0", width: "40%" }}>-₹ {Number(item.discountWallet).toFixed(2)}</td>
                            </tr>
                          )}
                          <tr style={{ borderTop: "1px dashed #000", fontWeight: "bold" }}>
                            <td style={{ textAlign: "left", padding: "6px 0 2px" }}>TOTAL PAID:</td>
                            <td style={{ textAlign: "right", padding: "6px 0 2px" }}>
                              ₹ {item?.allTotal ? Number(item.allTotal).toFixed(2) : "0.00"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Footer */}
                    <div style={{ marginTop: "15px", textAlign: "center", fontSize: "10px" }}>
                      <div>Invoice #: {item?.orderid || "-"}</div>
                      <div style={{ marginTop: "6px", fontWeight: "600" }}>Thank you for your order!</div>
                      <div>Visit us again soon</div>
                      <div style={{ borderTop: "1px dashed #000", marginTop: "10px", paddingTop: "10px" }}>
                        {moment().format("DD-MM-YYYY hh:mm A")}
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default MultipleInvoice;
